import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replacePlaceholders',
  standalone: true
})
export class ReplacePlaceholdersPipe implements PipeTransform {
  transform(text: string, replacements: (string | number)[]): string {
    let index = 0;
    return text.replace(/%[a-zA-Z]/g, () => {
      const replacement = replacements[index++];
      return replacement !== undefined ? String(replacement) : '';
    });
  }
}
